// Module
var code = "<div class=\"content-container\"> <h2 data-bind=\"restext: 'HomeTitle'\"></h2> <p data-bind=\"restext: 'HomeLeadText'\" class=\"lead\"></p> </div> ";
// Exports
export default code;